import { render, staticRenderFns } from "./SectionCommitments.component.vue?vue&type=template&id=a4913ac4&"
import script from "./SectionCommitments.component.vue?vue&type=script&lang=js&"
export * from "./SectionCommitments.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports